<template>
    <div class="person" v-show="showNextMsg">
       测试端
    </div>
</template>

<script>
// import { podsub } from 'utils/monitor'
export default {
    name:"personnel",
    data() {
        return {
                uid:1,
                action:"",
                callback: null,
                showNextMsg:false,
                searchText:"",
                perList:[]
        }
    },
    mounted(){
        
    },
    computed:{
        // 搜索符合坐席人员
        search:function(){
            if(this.perList){
                return this.perList.filter(item =>  item.tellername.includes(this.searchText))
            }else{
                return []
            }
        }
    },
    watch:{
        showNextMsg(val){
            if (val) {
                this.uid++;
            }
        }
    },
    methods:{
         getSafeClose() {
            const currentId = this.uid;
            return () => {
            this.$nextTick(() => {
                if (currentId === this.uid) this.doClose();
            });
            };
        },
        doClose(item){
            if (!this.showNextMsg) return;
            this.showNextMsg = false;
            setTimeout(() => {
                 if (this.action) this.callback(this.action, this, item);
            });
        },
        show(){
          this.showNextMsg = true
        }
    }
}
</script>

<style lang="less" scoped>
</style>